import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import React from 'react';
import PersonDataForm from './PersonDataForm';
import {FormattedMessage, useIntl} from 'react-intl';
import _ from 'lodash';
import {Field} from 'formik';
import {Form} from 'react-bootstrap';

/**
 * @param widgetId
 * @param index
 * @param remove
 * @param personDataConfig
 * @param roles
 * @param disabled
 * @returns {JSX.Element}
 * @constructor
 */
export const OtherPersonsListRow = ({widgetId, index, remove, personDataConfig, roles, disabled}) => {

    const intl = useIntl();

    // Rollen, die bereits auf andere Wege abgefragt werden, sollen hier nicht auswählbar sein
    roles = _.filter(roles, role => !_.includes([
        'SPEAKER', 'AUTHOR', 'CO_AUTHOR'
    ], role.staticId));

    const makeHandleOnChange = (field, form) => event => {
        const selectedRole = _.find(roles, role => role.id === event.target.value);
        form.setFieldValue(field.name, _.isEmpty(event.target.value) ? '' : selectedRole);
    };

    const getError = (field, form) => {
        return _.get(form.errors, field.name);
    };

    const isInvalid = (field, form) => {
        return _.get(form.touched, field.name) && getError(field, form);
    };

    return <div style={{marginBottom: '30px'}}>
        <PersonDataForm
            personPath={`widgets[${widgetId}][${index}].person`}
            personDataConfig={personDataConfig}
            placeholderLabel={false}
            disabled={disabled}
        />

        <Row>
            <Col>
                <Field name={`widgets[${widgetId}][${index}].role`}>
                    {({field, form}) => (
                        <Form.Group controlId={field.name}>
                            <Form.Label>
                                <FormattedMessage id="submission.form.label.role">
                                    {txt => <span className="required">{txt}</span>}
                                </FormattedMessage>
                            </Form.Label>
                            <Form.Control as="select"
                                          value={field.value ? field.value.id : ''}
                                          onBlur={field.onBlur}
                                          onChange={makeHandleOnChange(field, form)}
                                          isInvalid={isInvalid(field, form)}
                                          disabled={disabled}
                            >
                                <option value="">
                                    {intl.formatMessage({id: 'submission.form.select.emptyOption'})}
                                </option>
                                {roles.map((role, index) => (
                                    <option key={role.id} value={role.id}>
                                        {role.label[intl.locale]}
                                    </option>
                                ))}
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                                {getError(field, form)}
                            </Form.Control.Feedback>
                        </Form.Group>
                    )}
                </Field>
            </Col>
        </Row>

        <Row>
            <Col className="text-right">
                <Button type="button" variant="secondary" disabled={disabled} onClick={() => remove(index)}>
                    <i className="fa fa-trash-o" aria-hidden="true"/>
                    <FormattedMessage id="submission.form.persons.button.remove"/>
                </Button>
            </Col>
        </Row>
    </div>;
};

export default OtherPersonsListRow;
